<div class="login-container">
  <div class="login-wrapper">
    <div class="login-card">
      <!-- Brand Section -->
      <div class="login-brand">
        <div class="logo-icon">
          <img src="/images/logo.png" alt="Unpluggit" />
        </div>
        <div class="brand-text">
          <h1>I<span>MS</span></h1>
          <p>Inventory Management System</p>
        </div>
      </div>

      <!-- Welcome Section -->
      <div class="login-welcome">
        <h2>Forgot Password?</h2>
        <p>Enter your email to continue to password reset</p>
      </div>

      <!-- Reset Form -->
      <form class="login-form" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="email">Email Address</label>
          <div class="input-wrapper">
            <i class="bi bi-envelope"></i>
            <input
              type="email"
              id="email"
              name="email"
              [(ngModel)]="email"
              placeholder="Enter your email"
              required
            />
          </div>
        </div>

        <button type="submit" class="btn-login" [disabled]="isSubmitting">
          <i class="bi bi-arrow-right"></i>
          {{ isSubmitting ? 'Continuing...' : 'Continue' }}
        </button>
      </form>

      @if (errorMessage) {
        <div class="error-message show">
          <i class="bi bi-exclamation-circle"></i>
          <span>{{ errorMessage }}</span>
        </div>
      }

      <button type="button" class="back-to-login" (click)="backToLogin()">
        <i class="bi bi-arrow-left"></i>
        Back to Sign In
      </button>

      <!-- Footer -->
      <div class="login-footer">
        <p>&copy; 2026 IMS. All rights reserved.</p>
      </div>
    </div>

    <!-- Right Side Image/Branding -->
    <div class="login-banner">
      <div class="banner-content">
        <div class="banner-icon">
          <i class="bi bi-shield-lock"></i>
        </div>
        <h2>Password Recovery <br />Made Secure</h2>
        <p>Reset your password safely and get back to managing your inventory in no time.</p>
        <div class="banner-features">
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Secure reset links</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Email verification</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Time-limited tokens</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Account protection</span>
          </div>
        </div>
      </div>
      <div class="banner-footer">
        <span>Secure &bull; Reliable &bull; Professional</span>
      </div>
    </div>
  </div>
</div>
